<template>
    <div class="ah-progress-cell-item">
        <div class="top-infos">
            <slot name="percentage">
                <div
                    v-if="showProgress"
                    class="percentage-num"
                    :class="{
                        under: percentage < 0,
                        zero: percentage === 0,
                        doing: percentage > 0 && percentage < 100,
                        finish: percentage === 100,
                        over: percentage > 100,
                    }"
                >{{ percentage }} %</div>
            </slot>
            <slot name="top-right-infos" />
        </div>
        <el-progress
            v-if="showProgress"
            :stroke-width="4"
            :percentage="percentage > 100 ? 100 : percentage"
            :show-text="false"
            :color="colorByPercentage"
        />
        <div class="progress-info">
            <slot />
        </div>
    </div>
</template>
<script>
export default {
    name: 'ah-progress-cell-item',
    components: {
    },
    props: {
        percentage: {
            type: Number,
            default: 0,
        },
        colorZero: {
            type: String,
            default: '#cccccc',
        },
        colorDoing: {
            type: String,
            default: '#463cb2',
        },
        colorFinish: {
            type: String,
            default: '#92de56',
        },
        colorOver: {
            type: String,
            default: '#de4242',
        },
        colorUnder: {
            type: String,
            default: '#de4242',
        },
        showProgress: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        colorByPercentage() {
            if (this.percentage < 0) {
                return this.colorUnder;
            }
            if (this.percentage === 0) {
                return this.colorZero;
            }
            if (this.percentage > 0 && this.percentage < 100) {
                return this.colorDoing;
            }
            if (this.percentage === 100) {
                return this.colorFinish;
            }
            if (this.percentage > 100) {
                return this.colorOver;
            }
            return '#cccccc';
        },
    },
};
</script>
<style lang="scss">
.ah-progress-cell-item {
    --zero-color: #cccccc;
    --doing-color: #463cb2;
    --finish-color: #92de56;
    --over-color: #de4242;
    --under-color: #de4242;

    .top-infos {
        font-size: 9pt;
        display: flex;
        justify-content: space-between;
    }

    .percentage-num {
        font-size: 9pt;
        text-align: left;

        &.zero {
            color: var(--zero-color);
        }
        &.doing {
            color: var(--doing-color);
        }
        &.finish {
            color: var(--finish-color);
        }
        &.over {
            color: var(--over-color);
        }
    }
    .progress-info {
        margin-top: 10px;
        font-size: 9pt;
        color: #555;
        line-height: 130%;
        text-align: left;

        .money {
            font-weight: normal;
        }

        .space-between {
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>
